// extracted by mini-css-extract-plugin
export default {"modalOverlay":"TD-z","modalContent":"UD-z","header":"VD-z","close":"WD-z"};